import { createGraphqlApiHandler } from 'api/apollo-client'
import graphqlApi from 'api/graphql-api'
import appLoadingFeatureActions from 'feature/app-loading.actions'
import { GetCreateGameQueryVariables, GetOrderRewardQueryVariables } from 'graphql/generated/graphql'
import { Redux } from 'types/local'
import { createActionsSet } from 'utils/redux'

const types = {
  GET_GAME_DETAIL: createActionsSet.api('game-detail.get-game-detail'),
  GET_GAME_DETAIL_REWARD: createActionsSet.api('game-detail.get-game-detail-reward'),
  GET_SPIN_RESULTS: createActionsSet.api('game-detail.get-spin-results'),
}

const getGameDetailReward =
  (variables: GetOrderRewardQueryVariables) => async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
    dispatch({
      type: types.GET_GAME_DETAIL_REWARD.REQUEST,
    })
    dispatch(appLoadingFeatureActions.start())
    try {
      const handleApi = createGraphqlApiHandler(dispatch, getState)
      const response = await handleApi(graphqlApi.getMegaGameOrderReward(variables))
      dispatch({
        type: types.GET_GAME_DETAIL_REWARD.SUCCESS,
        payload: response,
      })
    } catch (e) {
      dispatch(appLoadingFeatureActions.finish())
      dispatch({ type: types.GET_GAME_DETAIL_REWARD.FAILED, payload: e })
    } finally {
      dispatch(appLoadingFeatureActions.finish())
    }
  }

const getGameDetailRewardInterval =
  (variables: GetOrderRewardQueryVariables) => async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
    dispatch({
      type: types.GET_GAME_DETAIL_REWARD.REQUEST,
    })

    try {
      const handleApi = createGraphqlApiHandler(dispatch, getState)
      const response = await handleApi(graphqlApi.getMegaGameOrderReward(variables))
      dispatch({
        type: types.GET_GAME_DETAIL_REWARD.SUCCESS,
        payload: response,
      })
    } catch (e) {
      dispatch({ type: types.GET_GAME_DETAIL_REWARD.FAILED, payload: e })
    }
  }

const getGameDetail =
  (variables: GetCreateGameQueryVariables) => async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
    dispatch({
      type: types.GET_GAME_DETAIL.REQUEST,
    })
    dispatch(appLoadingFeatureActions.start())
    try {
      const handleApi = createGraphqlApiHandler(dispatch, getState)
      const response = await handleApi(graphqlApi.getMegaGameContract(variables))
      dispatch({
        type: types.GET_GAME_DETAIL.SUCCESS,
        payload: response,
      })
      dispatch(getGameDetailReward({ idGame: response?.idGame, gameContract: response?.newGameContract }))
    } catch (e) {
      dispatch(appLoadingFeatureActions.finish())
      dispatch({ type: types.GET_GAME_DETAIL.FAILED, payload: e })
    } finally {
      dispatch(appLoadingFeatureActions.finish())
    }
  }
const getGameDetailInterval =
  (variables: GetCreateGameQueryVariables) => async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
    dispatch({
      type: types.GET_GAME_DETAIL.REQUEST,
    })
    try {
      const handleApi = createGraphqlApiHandler(dispatch, getState)
      const response = await handleApi(graphqlApi.getMegaGameContract(variables))
      dispatch({
        type: types.GET_GAME_DETAIL.SUCCESS,
        payload: response,
      })
      dispatch(getGameDetailRewardInterval({ idGame: response?.idGame, gameContract: response.newGameContract }))
    } catch (e) {
      dispatch({ type: types.GET_GAME_DETAIL.FAILED, payload: e })
    }
  }
const getSpinResults =
  (variables: GetCreateGameQueryVariables) => async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
    dispatch({
      type: types.GET_SPIN_RESULTS.REQUEST,
    })
    dispatch(appLoadingFeatureActions.start())
    try {
      const handleApi = createGraphqlApiHandler(dispatch, getState)
      const response = await handleApi(graphqlApi.getSpinResults({ id: variables.id }))
      dispatch({
        type: types.GET_SPIN_RESULTS.SUCCESS,
        payload: response,
      })
      dispatch(getGameDetailReward({ idGame: response?.idGame, gameContract: response?.orderRewards[0]?.gameContract }))
    } catch (e) {
      dispatch(appLoadingFeatureActions.finish())
      dispatch({ type: types.GET_SPIN_RESULTS.FAILED, payload: e })
    } finally {
      dispatch(appLoadingFeatureActions.finish())
    }
  }
export const gameDetailActions = {
  types,
  getGameDetail,
  getSpinResults,
  getGameDetailInterval,
  getGameDetailRewardInterval,
}
